export enum SortDirection {
    Ascending = <any>'Ascending',
    Descending = <any>"Descending"
}